import React, { useEffect } from 'react';
import styles from '../../styles/components/reports/QuestionReportExpanded.module.css';
import { QuestionReportPreviewData } from './QuestionReportPreview';
import QuestionSchema from '@ax2/common/model/schemas/QuestionSchema';
import { getReportTypes } from 'reports/reportTypesBuilder';
import QuestionResults from 'model/reports/QuestionResults';
import { getTemplateText } from '@ax2/common/helpers/template';
import { ReportTypeDropdown } from './ReportTypeDropdown';
import { ExportFn, getReport } from 'reports/reportBuilder';
import parse from 'html-react-parser';

export interface QuestionReportExpandedData extends QuestionReportPreviewData {
  question: QuestionSchema;
  results: QuestionResults;
  onNewExport: (getExportData: ExportFn) => void;
}

export const QuestionReportExpanded: React.FC<QuestionReportExpandedData> = ({
  question,
  results,
  onNewExport,
}) => {
  const rTypes = getReportTypes(question);
  const [reportType, setReportType] = React.useState(rTypes.defaultReport);
  const qText = 'content' in question ? getTemplateText(question.content) : '';
  const builder = getReport(qText, reportType, results);
  useEffect(() => {
    onNewExport(builder.getExportData);
  }, [onNewExport, builder.getExportData]);
  return (
    <div>
      <div className={styles.previewContainer}>
        <div className={styles.questionContainer}>
          <span className={styles.title}>Your question</span>
          <span className={styles.questionText}>
            {'content' in question
              ? parse(getTemplateText(question.content))
              : 'Empty question content'}
          </span>
        </div>
        <div className={styles.reportTypeContainer}>
          <span className={styles.title}>Report Type</span>
          <div className={styles.dropdown}>
            <ReportTypeDropdown
              value={reportType}
              options={rTypes.allowedReports}
              disabled={rTypes.allowedReports.length < 2}
              onChange={setReportType}
            />
          </div>
        </div>
      </div>
      <div className={styles.chartContainer}>{builder.element}</div>
    </div>
  );
};
